import { render, staticRenderFns } from "./orderItemApplyAllSupplierPopover.vue?vue&type=template&id=4edec5ce&"
import script from "./orderItemApplyAllSupplierPopover.vue?vue&type=script&lang=js&"
export * from "./orderItemApplyAllSupplierPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports